import { MyChartDomain } from '@Praia-Health/spi-common-utils/types';
import { ClientConfig, ClientMyChartConfig } from '../../clientConfig';

export function getMyChartSamlSSOFromSystemAndBrand(clientConfiguration: ClientConfig, system: string, brand: string): string | undefined {
    const foundDomain = findMyChartBySystemAndBrand(clientConfiguration.myChartConfig, system, brand);
    if (foundDomain) {
        const idp = foundDomain.idp || 'SSO';
        return `https://${foundDomain.domain}/${foundDomain.subDomain}/Authentication/Saml/Login?idp=${idp}`;
    }
}

export function getMyChartLandingPageFromSystemAndBrand(clientConfiguration: ClientConfig, system: string, brand: string): string | undefined {
    const foundDomain = findMyChartBySystemAndBrand(clientConfiguration.myChartConfig, system, brand);
    if (foundDomain) {
        return `https://${foundDomain.domain}/${foundDomain.subDomain}/Authentication/Login`;
    }
}

function findMyChartBySystemAndBrand(myChartConfig: ClientMyChartConfig | undefined, system: string, brand: string): MyChartDomain | undefined {
    const myChartDomains = myChartConfig?.domains;
    if (!myChartDomains) {
        return undefined;
    }

    const foundDomain = Object.values(myChartDomains).find((myChartDomain) => {
        return myChartDomain.brand.toLowerCase() === brand?.toLowerCase() && system.endsWith(myChartDomain.epic);
    });
    return foundDomain as MyChartDomain | undefined;
}

export function getSystemFromMyChartUrl(clientConfig: ClientConfig, url: string) {
    if (!url) {
        throw new Error('getSystemFromMyChartUrl(): URL is missing');
    }
    const mychartConfig = clientConfig.myChartConfig;
    if (!mychartConfig?.domains) {
        throw new Error(`Invalid client configuration: myChartConfig is missing or does not contain any domains`);
    }

    const mychartDomain = Object.values(mychartConfig.domains).find((mychartSite: MyChartDomain) => {
        return url.includes(mychartSite.domain);
    });

    if (mychartDomain) {
        return getFullyQualifiedEhrSystemName(clientConfig, mychartDomain.epic);
    } else {
        throw new Error(`URL: ${url} does not map to any known EHR system`);
    }
}

export function getFullyQualifiedEhrSystemName(clientConfig: ClientConfig, ehrRegion: string) {
    return `${clientConfig.ehrPrefix}.${ehrRegion}`;
}
